import { Divider } from 'antd';
import styles from '@/scene/modal/index.module.scss'

const contents = {
    en:{
        modal_back_btn: 'BACK',
        modal_shop_btn: 'SHOP',
        modal_download_btn: 'DOWNLOAD',
        modal_img_show_icon: require('@/files/modal/imglist/zoomIn.png'),
        modal_click_img: require('@/files/modal/clickHand.png'),
        modal_swiper_img: require('@/files/modal/leftRightHand.png'),


        modal_s1_w1_video_title: <>The symbiosis of art and beauty</>,
        modal_s1_w1_video_subtitle: 'Appreciate the art and see the beauty',
        modal_s1_w1_video_content: <>Enter the world of CEMÔY, where inspiration and vision derives from the perception and details of beauty and aesthetic. Holding importance in the appreciation of creating, in which every step is the creation of a masterpiece. We invite you to “SEE MORE” through our creative director’s interpretation of beauty. Start a dialogue between art and aesthetic, appreciate the dedication of creativity in the works of art and allow beauty and style to endlessly inspire.</>,
        modal_s1_w1_video_img: require('@/files/modal/img/CEMOY-Gallery-S01-W1-P1-S-CD.jpg'),
        modal_s1_w1_video_video: require('@/files/modal/video/CEMOY-Gallery-S01-W1-V1-EN-CD.mp4'),

        modal_s2_w1_imglist_title: <>Encapsulating pieces of Australia</>,
        modal_s2_w1_imglist_subtitle: 'The untold creativity searched far and wide.',
        modal_s2_w1_imglist_content: [
            <><h1>Guardian of the olive tree grove</h1>
            <br />
            <h2>Discovering the secrets of natural healing through each breath.</h2>
                <br />
            Year: 2019
                <br />
            Medium(s): Pen and Ink Painting
                <br /><br />
            The early morning dew falls upon the olive grove as the flowers freely blossoms. After the winter hibernation, we transition into a more livelier world. As the sun shines through, spring welcomes the gorgeous blooming white flowers and the wakening of the leafy branches as it reaches, grows and intertwine with its surrounding. The numbat freely shuffles along with the emu following closely behind and all are draped in beautiful ornate jewellery. Ampoule-shaped bottles transforms into musical instruments, listen carefully and you will hear the distinct notes ringing as the animals move along. At this moment, there is a sense of calm, we let everything go, enjoy the moment and allow nature to heal and let the repairing process take its course.
            <Divider className={styles.contentDivider} />
            Hydra Ampoule Face Mask
                <br /> <br />
            In this narrative, the olive trees guard some of Australia’s national treasures, the emu and numbat. With the Hydra Ampoule Seaweed Repair mask being rich in olive leaf extract, it will certainly give your skin all the protection and hydration that is required to feel balanced and nourished.</>,
            <><h1>The sensational land of Pomegranate</h1>
                <br />
                <h2> Enter into the fantastical world of the awe-inspiring nature and Australia’s fauna.</h2>
                <br />
                Year: 2019
                <br />
                Medium(s): Pen and Ink Painting
                <br /><br />
                Step into the ethereal forest of Australia and be surrounded by the gorgeous blooming pomegranate flowers. Become captivated by the great Bird-of-paradise and witness the Australian wombat, cockatoo and possums frolic in amongst the blooms. A picturesque moment, capturing the animals at their happiest and most playful state. Our imagination allows us to blissfully enjoy this moment for ourselves, surrendering to the beauty and playfulness of nature and the satisfaction yet to gain.
                <Divider className={styles.contentDivider} />
                Pomegranate Energetic Vitality Face Mask
                <br /> <br />
                The sheet mask is saturated in Australian pomegranate essence. Like the lively Australian possum filled with energy and strength, the essence stimulates the skin, giving renewed vitality with a noticeable healthy and radiant complexion.</>,
            <><h1>Catch the waves of the powerful ocean</h1>
                <br />
                <h2>Tides surging from the vast ocean, delivering the source of vitality.</h2>
                <br />
                Year: 2019
                <br />
                Medium(s): Pen and Ink Painting
                <br /><br />
                Dive deep into the infinite blue water to be amongst the school of fish and seek-out the Australian platypus swimming freely. The clicking dolphins and breaching whale, along with the exotic corals and surging waves, all emanate power, vitality and the sense of freedom. Everything evokes calmness and with the complete intertwining of nature with body and mind, a surge of endless power is ignited.
                <Divider className={styles.contentDivider} />
                Marine Boost Collagen Face Mask
                <br /> <br />
                CEMÔY seeks inspiration from the deep blue ocean. Tucked away are the rich nutrients that will hydrate, repair and firms the skin for a boost of youthfulness and radiance.</>,
            <><h1>Be served by the manuka pollinated bees</h1>
                <br />
                <h2> Embrace nature to heal the soul.</h2>
                <br />
                Year: 2019
                <br />
                Medium(s): Pen and Ink Painting
                <br /><br />
                Retreat into the sea of blossoming flowers and soak in the aroma of the rich Manuka honey. Allow the gentle and therapeutic fragrance of the flowers drift through the air and awaken your senses. The Queen Bee is perched upon the flower, whilst overlooking her diligent working bees. A moment of delightfulness as the petals fall upon the shawl of the Queen Kangaroo, displaying a striking pattern. All the while, as she lays there the nutrients of the honey absorb and protect her golden hair.
                <Divider className={styles.contentDivider} />
                Manuka Honey Ultra Recovery Face Mask
                <br /> <br />
                The Manuka Honey Mask deeply nourishes and rejuvenates the skin with premium ingredients from the Australian landscape. Delivering a luxurious spa experience, the mask will leave the skin feeling energised and renewed.</>],
        modal_s2_w1_imglist_url: [
            // 'https://shop.cemoy.com.au/products/hydra-ampoule-face-mask',
            // 'https://shop.cemoy.com.au/products/pomegranate-energetic-vitality-face-mask',
            // 'https://shop.cemoy.com.au/products/marine-boost-collagen-face-mask',
            // 'https://shop.cemoy.com.au/products/manuka-honey-ultra-recovery-face-mask'
               'https://shop.cemoy.com.au/collections/mask-collection',
               'https://shop.cemoy.com.au/collections/mask-collection',
               'https://shop.cemoy.com.au/collections/mask-collection',
               'https://shop.cemoy.com.au/collections/mask-collection'
        ],
        modal_s2_w1_imglist_sizes:[
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
        ],
        modal_s2_w1_imglist_sizes_mobile:[
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
        ],
        modal_s2_w1_imglist_imglist: [
          {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S02-W1-P1-Ampoule.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S02-W1-P1-Ampoule.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S02-W1-P1-Ampoule.jpg'),
            thumbnailWidth: '50vw'
          },
          {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S02-W1-P2-Pomegranate.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S02-W1-P2-Pomegranate.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S02-W1-P2-Pomegranate.jpg'),
            thumbnailWidth: '50vw'
          },
          {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S02-W1-P3-Ocean.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S02-W1-P3-Ocean.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S02-W1-P3-Ocean.jpg'),
            thumbnailWidth: '50vw'
          },
          {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S02-W1-P4-Honey.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S02-W1-P4-Honey.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S02-W1-P4-Honey.jpg'),
            thumbnailWidth: '50vw'
          }
        ],

        modal_s3_w1_img_title: <>Beauty, <br />an eternally blooming flower</>,
        modal_s3_w1_img_subtitle: 'Everlasting craftsmanship of beauty.',
        modal_s3_w1_img_content: <>Year: 2020
            <br />
            Medium(s): Gouche Painting
            <br /><br />
            The colour and beauty of the blooming flowers leads you through the gate of the garden. As you pass through the graceful glistening waterfall, you catch the scent of the fragrant wonderland and be exposed to the mottled shadows of the trees and the perfectly intertwined image of light and shadow. Certain petals are like intricate embroidery, created with exquisite craftsmanship. The beauty and ingenuity of each needlework are engraved into the fabric, a tribute to lasting beauty and the work and heart that goes into the creation of each product.
            <Divider className={styles.contentDivider} />
            Timekeeper Eye Serum
            <br /> <br />
            CEMÔY is an advocate of natural skin care combined with the advancements in technological research. The idea of excellence and luxury does not only apply to skincare and beauty, but also reflects into ones attitude and lifestyle. It is the utmost importance to develop and create our products revolving around this belief. When the flowers bloom, another beauty is revealed, a continuous cycle of everlasting beauty.</>,
        modal_s3_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S03-W1-P1-S-Timekeeper.jpg'),
        modal_s3_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S03-W1-P1-Timekeeper.jpg'),
        modal_s3_w1_img_url: 'https://shop.cemoy.com.au/products/timekeeper-eye-serum',
        modal_s3_w1_img_sizes: [70, 80, 90, 100],
        modal_s3_w1_img_sizes_mobile: [90, 100, 110, 120],

        modal_s4_w1_img_title: <>Delve into our extensive process</>,
        modal_s4_w1_img_subtitle: 'Boundless research, the start of advanced restoration.',
        modal_s4_w1_img_content: <>Year: 2018
            <br />
            Medium(s): Pen Illustration
            <br /><br />
            The vast pure Australian landscape brings endless opportunities for CEMÔY to pursuit its journey in search for the ultimate natural ingredient to repair the skin. With absolute determination, searching high and low, far and wide, from mountains, rivers, forest and into the depths of the ocean to gather the scarce plant extracts. After countless trials and formulations, the pharmacists in the CEMÔY laboratories finally developed the brand’s ultimate product -  the 21 Day Essence Series. Packed with rare natural plant extracts from land and sea combined with the advanced technology developed, the result is a powerful serum to enhance the the skins radiance.
            <Divider className={styles.contentDivider} />
            21 Day Series
            <br /> <br />
            The “Process Map” illustrates the overall narrative of researching, developing and fabricating the 21 Day Essence Series. It depicts the actual product development excellence at CEMÔY where every attention to detail is made to ensure the ultimate skin rejuvenation is brought into existence.</>,
        modal_s4_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S04-W1-P1-S-21-Day.jpg'),
        modal_s4_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S04-W1-P1-21-Day.jpg'),
        modal_s4_w1_img_url: 'https://shop.cemoy.com.au/collections/21-day-series',
        modal_s4_w1_img_sizes: [70, 80, 90, 100],
        modal_s4_w1_img_sizes_mobile: [90, 100, 110, 120],

        modal_s5_w1_img_title: <>A cumulation of treasured belongings </>,
        modal_s5_w1_img_subtitle: 'Encountering beauty, your best friend.',
        modal_s5_w1_img_content: <>Year: 2021
            <br />
            Medium(s): Colour Pencil and Digital Illustration
            <br /><br />
            Inspired by companionship, we begin a journey of exploring youthful skin with the incorporation of scientifically researched ingredients that repairs and nourishes. The illustrations depicts varying elements that can be found within a boudoir. From ribbons, cloths and tassels symbolic of beautiful outfits to treasured boxes and mirrors representing time to crowns and sceptres symbolising self-confidence and an independent spirit. The vision this series wishes to convey is that the collection of what is considered “treasures” are representative of the hope that a woman will always feel beautiful and be filled with confidence.
            <Divider className={styles.contentDivider} />
            Orbital Prestige Series
            <br /> <br />
            CEMÔY aspires for the Orbital Prestige Series to become a part of the “things in the boudoir”, where it is a necessity for the consumer. Accompanying them to experience the growing beauty and nourishment over time. </>,
        modal_s5_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S05-W1-P1-S-Orbital-Prestige.jpg'),
        modal_s5_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S05-W1-P1-Orbital-Prestige.jpg'),
        modal_s5_w1_img_url: 'https://shop.cemoy.com.au/collections/orbital-prestige-series',
        modal_s5_w1_img_sizes: [70, 80, 90, 100],
        modal_s5_w1_img_sizes_mobile: [90, 100, 110, 120],

        modal_s6_w1_img_title: <>Showered by love and soak in the sunlight</>,
        modal_s6_w1_img_subtitle: 'Thrive in the sun where the love of beauty has no boundaries.',
        modal_s6_w1_img_content: <>Year: 2019
            <br />
            Medium(s): Digital Illustration
            <br /><br />
            The tale behind the Re-Vital Expert Defence is the combining of ancient Greek mythology with the advanced research of modern technology. Inspired by the mythical story in which Apollo, the god of the sun and light, protected his beloved Daphne from the scorching sun with his shawl and allowing her to enjoy its rays freely. The artwork depicting a modern scenario in which Apollo and Daphne are able to frolic and bask in the sunshine of the iconic landscape of Australia’s Bondi Beach.
            <Divider className={styles.contentDivider} />
            Re-Vital Expert Defence
            <br /> <br />
            CEMÔY seeks to provide the optimum care and protection against the sun for everyone. With its lustrous formulation and integrated sun protection, the Re-Vital Expert Defence is the ideal protector of the skin against the sun.</>,
        modal_s6_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S06-W1-P1-S-Sun.jpg'),
        modal_s6_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S06-W1-P1-Sun.jpg'),
        modal_s6_w1_img_url: 'https://shop.cemoy.com.au/products/re-vital-expert-defence',
        modal_s6_w1_img_sizes: [70, 80, 90, 100],
        modal_s6_w1_img_sizes_mobile: [90, 100, 110, 120],

        modal_s7_w1_img_title: <>Shine brilliantly as your dreams unfold</>,
        modal_s7_w1_img_subtitle: 'The Inception of your dream, is the exploration of your beauty.',
        modal_s7_w1_img_content: <>Year: 2020
            <br />
            Medium(s): Watercolour Painting
            <br /><br />
            The Inception Sleeping Mask repairs as you enter a dreaming state. Consisting of powerful natural ingredients, its power is release during the ‘golden’ period every night. We enter a complex universe, where flowers bloom, petals soar and intertwine with the surrounding architectural structures. Falling into a fragment of an extraordinary dream where we can explore eternal beauty.
            <Divider className={styles.contentDivider} />
            Inception Sleeping Cream & Mask
            <br /> <br />
            In addition to the neutral colours of the flowers and architectures, the colour palette of gold and sapphire blue reflects the theme of the brand. We are invited into the dream garden of CEMÔY, to embark on a journey and witness the gracefulness and elegance of the art echoing the luxuriousness and efficacy of the products.</>,
        modal_s7_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S07-W1-P1-S-Inception.jpg'),
        modal_s7_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S07-W1-P1-Inception.jpg'),
        modal_s7_w1_img_url: 'https://shop.cemoy.com.au/products/inception-sleeping-cream-mask',
        modal_s7_w1_img_sizes: [70, 80, 90, 100],
        modal_s7_w1_img_sizes_mobile: [90, 100, 110, 120],

        modal_s8_w1_imglist_title: <>The golden tarot of Visconti-Sforza</>,
        modal_s8_w1_imglist_subtitle: 'To be inspired by the mysterious secrets and ways.',
        modal_s8_w1_imglist_content: [<>Year: 2021
            <br />
            Medium(s): Pen Illustration
            <br /><br />
            A detailed illustration highlighting the secret garden of Australia and the mysterious and fantastical world of tarot cards. Paying tribute to the power of beauty, embark on a walk through a moonlit night filled with beauty, love and romance in full bloom. Depictions of a goddess symbolic of new hope and infinite possibilities, a priestess, representing wisdom and intuition and a joker embodying the spirit full of dreams and courage. Every detail has meaning highlighting the strength, vitality, hope, courage and the endless pursuit to obtaining beauty. It is a journey of spiritual exploration, self-discovery and visual enjoyment.
            <Divider className={styles.contentDivider} />
            Meadowfoam Moistening Oil
            <br /> <br />
            CEMÔY draws inspiration from images of the oldest existing Visconti-Sforza tarot cards. It traces back to the ancient secrets and ways of nourishing and healing the skin. Implementing thousands of years of utilising natural plant extracts such as that of the Meadowfoam seed oil to gently heal the skin and begin the rejuvenation journey. </>,
            // <>xxxxxxxxxxxxxxx2</>,
            // <>xxxxxxxxxxxxxxx3</>,
            // <>xxxxxxxxxxxxxxx4</>,
            // <>xxxxxxxxxxxxxxx5</>,
            // <>xxxxxxxxxxxxxxx6</>,
            // <>xxxxxxxxxxxxxxx7</>
        ],
        modal_s8_w1_imglist_sizes:[
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
        ],
        modal_s8_w1_imglist_sizes_mobile:[
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
        ],
        modal_s8_w1_imglist_url: 'https://shop.cemoy.com.au/products/meadowfoam-moistening-oil',
        modal_s8_w1_imglist_imglist: [
          {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P1-S-Taro.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P1-S-Taro.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S08-W1-P1-Taro.jpg'),
            thumbnailWidth: '50vw'
          },
          {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P2-S-Taro.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P2-S-Taro.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S08-W1-P2-Taro.jpg'),
            thumbnailWidth: '50vw'
          },
          {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P3-S-Taro.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P3-S-Taro.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S08-W1-P3-Taro.jpg'),
            thumbnailWidth: '50vw'
          },
          {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P4-S-Taro.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P4-S-Taro.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S08-W1-P4-Taro.jpg'),
            thumbnailWidth: '50vw'
          },
          {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P5-S-Taro.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P5-S-Taro.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S08-W1-P5-Taro.jpg'),
            thumbnailWidth: '50vw'
          },
          {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P6-S-Taro.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P6-S-Taro.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S08-W1-P6-Taro.jpg'),
            thumbnailWidth: '50vw'
          },
          {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P7-S-Taro.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P7-S-Taro.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S08-W1-P7-Taro.jpg'),
            thumbnailWidth: '50vw'
          }
        ],

        modal_s9_w1_img_title: <>Illuminate the gaze</>,
        modal_s9_w1_img_subtitle: 'Shine and glisten as time passes.',
        modal_s9_w1_img_content: <>Year: 2020
            <br />
            Medium(s): Digital Illustration
            <br /><br />
            When connected, this continuous pattern creates a cylindrical form composed of various mandala motifs. Mirroring a kaleidoscope, it forms numerous dazzling geometrics that glistens and shines as the light refracts the surface. Like the marking of the hour lines on the sun dial plate, the dotted lines around the illustrations reflects the dazzling golden light, a reminder to slow-down, enjoy the process and beauty of skin care and continue to maintain ones youth and charm.
            <Divider className={styles.contentDivider} />
            Timekeeper Eye Serum
            <br /><br />
            The illustration is inspired by the dazzling of diamonds and the concept of the sundial as a teller of time. As time passes, we see the effect it has on the skin around the eyes. With CEMÔY’s Timekeeper Eye Serum, we continue to preserve the glimmer in ones eyes and erase the traces of time.</>,
        modal_s9_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S09-W1-P1-S-Timekeeper.jpg'),
        modal_s9_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S09-W1-P1-Timekeeper.jpg'),
        modal_s9_w1_img_url: 'https://shop.cemoy.com.au/products/timekeeper-eye-serum',
        modal_s9_w1_img_sizes: [70, 80, 90, 100],
        modal_s9_w1_img_sizes_mobile: [90, 100, 110, 120],

        modal_s10_w1_img_title: <>Ascend into the celestial</>,
        modal_s10_w1_img_subtitle: 'Defy gravity to embrace the inevitable.',
        modal_s10_w1_img_content: <>Year: 2019
            <br />
            Medium(s): Colour Pencil
            <br /><br />
            The realm of an imaginary world is opening and we encounter plants and flowers of this mystical place. As the fragrance flows through the air and the peculiar plants flourish tenaciously, this fantasy world is filled with unwavering vitality. Thriving branches bearing fruits sways with the wind against the backdrop of a starry sky. We cannot help but be drawn to the beauty of this sea of exotic flowers.
            <Divider className={styles.contentDivider} />
            Galaxy 4D Eye Cream
            <br /><br />
            We have transcended into space, to an alternative universe where exotic flowers and plants grow vigorously beneath the starlit blue sky. The concept of going beyond earth and anti-gravity, is accentuated in the power of the Galaxy 4D Eye cream. It challenges gravity and combats wrinkles developed around the delicate skin of the eyes.</>,
        modal_s10_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S10-W1-P1-S-Galaxy.jpg'),
        modal_s10_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S10-W1-P1-Galaxy.jpg'),
        modal_s10_w1_img_url: 'https://shop.cemoy.com.au/products/galaxy-4d-eye-cream',
        modal_s10_w1_img_sizes: [70, 80, 90, 100],
        modal_s10_w1_img_sizes_mobile: [90, 100, 110, 120],

        modal_s11_w1_imglist_title: <>Compilation of the elite</>,
        modal_s11_w1_imglist_subtitle: 'Consolidated and perfection highlighted without restrain or limit.',
        modal_s11_w1_imglist_content: [<>
            <h1>The collection of classics</h1>
            <br />
            <h2>A collector and conserver of the years.</h2>
            <br />
            Year: 2019
            <br />
            Medium(s): Digital Illustration
            <br /><br />
            The ornate frame is embellished with a refined and tasteful style. Highlighted through the bows and elegant silk satin ribbons, together with the botanical core element of each product depicted in the entwined golden illustrations. This collection illuminates the skin in a delicate and lively manner, expressing the fresh and free nature of youthfulness. With the four products distinctly displayed upon the cover, it aims to be considered as the “classics”, the recurring product that consumers turn to.
            <Divider className={styles.contentDivider} />
            Lumen Special Edition - Reserve
            <br /> <br />
            Made up of natural ingredients and leading science and technology, The Lumen Series consisting of 17 different luxurious botanical ingredients is dedicated to everyone. Especially to those who bravely seeks beauty in a pursuit for a future enriched with light and youthfulness.</>,
            <><h1>Rays of light and beauty</h1>
                <br />
                <h2>The gleaming lumens radiating blissfulness.</h2>
                <br />
                Year: 2021
                <br />
                Medium(s): Pen and Digital Illustration
                <br /><br />
                Light has travelled hundreds of millions of light-years across the universe and has finally arrived. The dazzling light beams from the distance, the crystal clearness of the pomegranate seeds symbolic of ones’ prosperity becomes evident. Together with the element of the three chess pieces - King, Queen and Knight, it signifies the hopes of bringing in new life, success and strength. Like a new plant that prosper under the sun, it is born to become a symbol of light and beauty.
                <Divider className={styles.contentDivider} />
                Lumen Special Edition - Floral
                <br /> <br />
                Named after the unit of luminous flux, the series is composed of rare plant extracts that have been searched for beneath the sea and on land. Infused with absolute repairing power, upon application the skin becomes more luminous, softer and supple.</>,
            <><h1>Uncovering the secret realm</h1>
                <br />
                <h2>Follow the light to discover the treasure of beauty.</h2>
                <br />
                Year: 2021
                <br />
                Medium(s): Pen and Ink Painting
                <br /><br />
                The beaming light leads one to the hidden temple tucked away in a mysterious and mystical forest. The run-down temple magnificently stand amongst the surrounding nature, with its light emanating and overpowering any darkness or shadows intended to hide it. The top of the temple resembles a Möbius ring, symbolising its eternal light and strength.
                <Divider className={styles.contentDivider} />
                Lumen Special Edition - Mystical
                <br /> <br />
                The journey of seeking beauty is accompanied by the light of the Lumen Collection Gift Set. With the repairing power that reveals the glowing beauty guiding you to embark on a rewarding treasure hunt. Open the doors of the temple to awaken the radiance from within and unveil the beauty of your skin.</>,
            <><h1>Flowering freshness and beauty</h1>
                <br />
                <h2>Day by day growth, highlighting the tenacity to fully bloom.</h2>
                <br />
                Year: 2021
                <br />
                Medium(s): Acrylic Painting
                <br /><br />
                Beauty is not just about the roses, every flower, tree and plant has its own definition of beauty. Whether it be the purslane, witch hazel, snow lotus or the sea fennel, they all have the opportunity to prosper and bloom in CEMÔY’s abundant garden. Beauty does not have a singular definition, it is fearless of the sun, wind and rain. It has the opportunity to be free, proud and everlasting.
                <Divider className={styles.contentDivider} />
                Lumen Special Edition - Garden
                <br /> <br />
                In a limited edition of the Lumen Series, CEMÔY illustrates beauty in full bloom. It highlights the meaning behind the name - the measure of visible light emitted by a source, in this case the lustrousness of the skin.</>,
            <><h1>Be the light that shines for all</h1>
                <br />
                <h2>Take centre stage and shine.</h2>
                <br />
                Year: 2021
                <br />
                Medium(s): Digital Illustration
                <br /><br />
                Covered with detailed metal decor and exquisite hand carvings, the Baroque style swept the dressers of every woman in Europe during the 16th Century. A style exhibiting luxury, enthusiasm and self-confidence illustrated through a stage set. With core botanical ingredients in the products depicted in fine detailed drawings, this set is made to encourage everyone to be fearless and light up the stage.
                <Divider className={styles.contentDivider} />
                Lumen Special Edition - Stage
                <br /> <br />
                The gift box of luminosity aims to nourish, illuminates and softens the skin. Like the star of the show, it gives you the self-confidence to take centre stage and let your light shine.</>],
        modal_s11_w1_imglist_url: [
          // 'https://shop.cemoy.com.au/products/lumen-collection-gift-set-toner-lotion',
          // 'https://shop.cemoy.com.au/products/lumen-special-edition-floral',
          // '',
          // 'https://shop.cemoy.com.au/products/lumen-special-edition-garden',
          // ''
            'https://shop.cemoy.com.au/collections/gift-kits',
            'https://shop.cemoy.com.au/collections/gift-kits',
            'https://shop.cemoy.com.au/collections/gift-kits',
            'https://shop.cemoy.com.au/collections/gift-kits',
            'https://shop.cemoy.com.au/collections/gift-kits',
        ],
        modal_s11_w1_imglist_sizes:[
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
        ],
        modal_s11_w1_imglist_sizes_mobile:[
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
        ],
        modal_s11_w1_imglist_imglist: [
          {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P1-S-Classics.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P1-S-Classics.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S11-W1-P1-Classics.jpg'),
            thumbnailWidth: '50vw'
          },
          {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P2-S-Hope.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P2-S-Hope.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S11-W1-P2-Hope.jpg'),
            thumbnailWidth: '50vw'
          },
          {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P3-S-Secret.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P3-S-Secret.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S11-W1-P3-Secret.jpg'),
            thumbnailWidth: '50vw'
          },
          {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P4-S-Freshness.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P4-S-Freshness.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S11-W1-P4-Freshness.jpg'),
            thumbnailWidth: '50vw'
          },
          {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P5-S-Stage.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P5-S-Stage.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S11-W1-P5-Stage.jpg'),
            thumbnailWidth: '50vw'
          }
        ],

        modal_s12_w1_img_title: <>The garden of restoration and illumination</>,
        modal_s12_w1_img_subtitle: 'Dreaming under the starry night sky, we encounter a boundless garden.',
        modal_s12_w1_img_content: <>Year: 2018
            <br />
            Medium(s): Hand and Digital Illustrations
            <br /><br />
            As we step foot into a secret garden, covered with purslane and witch hazel we begin the journey of exploration and restoration from the extracts of nature. The garden is dense in unique florals and foliage, there appears to be no end as far as the eye can see. Listen closely and you will be able to catch the whispers of the resurrection grass and sea fennel swaying in the wind. To be surrounded by the healing nature, the heart is content. This feels like a dream, one that we want to embrace, cherish and sink deep into without ever wanting to wake up.
            <Divider className={styles.contentDivider} />
            The Lumen Series
            <br /> <br />
            This series highlights the 17 unique natural ingredients from the original Lumen Series. It pays tribute to the Research & Development team at CEMÔY, who has tirelessly worked towards creating and evolving this collection. It echoes the core belief of the brand in which skincare is developed through the combination of the finest natural ingredients and cutting-edge technology. The Lumen Series seeks to illuminate the skin through its research into rare plant extracts from the land and sea and supplement with advanced technological research to fully express its power to repair.</>,
        modal_s12_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S12-W1-P1-S-Lumen.jpg'),
        modal_s12_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S12-W1-P1-Lumen.jpg'),
        modal_s12_w1_img_url: 'https://shop.cemoy.com.au/collections/the-lumen-series',
        modal_s12_w1_img_sizes: [70, 80, 90, 100],
        modal_s12_w1_img_sizes_mobile: [90, 100, 110, 120],

        modal_s13_w1_img_title: <>Awaken <br />the life from within</>,
        modal_s13_w1_img_subtitle: 'The commencement of eternal life.',
        modal_s13_w1_img_content: <>Year: 2019
            <br />
            Medium(s): Pen, Watercolour and Collage
            <br /><br />
            A toile pattern illustrating the Australian landscape including the active creatures to the enriched soil cultivating the plants, all of which inspires CEMÔY's range of skincare. The surprising discovery of skin repairing ingredients such a cermaides, in the prestigious Barossa Valley of South Australia, makes nature no exception to being miracle workers. Everything nature inhabits is a revelation of its astonishing power.
            <Divider className={styles.contentDivider} />
            30-Second Miracle Toner
            <br /> <br />
            Through incorporating the many forms of natural life in the artwork, it is an analogy of the product offering life to the skin in its hydrating and repairing properties in which vitality is attained.</>,
        modal_s13_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S13-W1-P1-S-Eternal.jpg'),
        modal_s13_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S13-W1-P1-Eternal.jpg'),
        modal_s13_w1_img_url: 'https://shop.cemoy.com.au/products/30-second-miracle-toner',
        modal_s13_w1_img_sizes: [30, 40, 50, 60],
        modal_s13_w1_img_sizes_mobile: [80, 85, 90, 100],

        modal_s14_w1_video_title: <>Celebrating the artistry of the artisans</>,
        modal_s14_w1_video_subtitle: ' Ingenuity and formation.',
        modal_s14_w1_video_content: <>Through intricate craftsmanship CEMÔY presents the interconnection of exploring beauty and dedication to the fine details. We awaken the beauty of the skin, by delving into nature, devoting time and effort and polishing the defining attributes. Each step of the process is meticulously crafted with a balance between contemporary trends and what defines the ultimate aesthetic, all the while aspiring to instil a ritualistic skincare experience. Every effort is made to highlight the core beliefs of CEMÔY, not only in bringing beauty to the skin but through its ingenuity, innovation and craftsmanship. Every detail of the product and encounter is considered, ensuring a gradual and fulfilling journey of beauty.</>,
        modal_s14_w1_video_img: require('@/files/modal/img/CEMOY-Gallery-S14-W1-P1-S-Craftsmanship.jpg'),
        modal_s14_w1_video_video: require('@/files/modal/video/CEMOY-Gallery-S14-W1-V1-Craftsmanship.mp4'),

        modal_s14_w2_video_title: <>Immerse in exclusivity and insightfulness </>,
        modal_s14_w2_video_subtitle: 'To understand and grasp inspiration.',
        modal_s14_w2_video_content: <>Exhibiting an exterior of luxury with a basis of exceptional quality, this constitutes the ideal of CEMÔY. Driven by the power of nature and its miraculous restoring ways, we integrate the extraction of premium natural ingredients with advancements in bio-technology to unveil a world of incomparable skincare experience. With CEMÔY’s dedication to being creators of beauty, every aspect of design is carefully considered. From sourcing the elements to the breakthroughs in scientific research and the art and craftsmanship of the products, each masterpiece illustrates a story in pursuit of an unparalleled skincare experience.
            <br /><br />
            Immerse in the fusion of the senses, recognise its beauty and realise this is the commencement of your journey with CEMÔY.
        </>,
        modal_s14_w2_video_img: require('@/files/modal/img/CEMOY-Gallery-S14-W2-P1-S-Spa.jpg'),
        modal_s14_w2_video_video: require('@/files/modal/video/CEMOY-Gallery-S14-W2-V1-EN-Spa.mp4.mp4'),



        // -------以下做备份使用

        mask_modal_title: <>MASK<br />COLLECTION</>,
        mask_modal_subtitle: 'DISCOVER THE VERY ESSENCE OF BEAUTY',
        mask_modal_content: <>Paying homage to the innate beauty of Australia's natural habitat, CEMÔY's mask collection depicts the plants and flowers that makeup the core ingredients of each product.
            <br />
            <br />
            Forming an occlusive layer on your skin with a concentrated cocktail of repairing and hydrating ingredients, each mask visibly plumps and energizes for a renewed radiance and luminous glow in minutes.
        </>,
        mask_modal_img: require('@/files/modal/maskCollection/maskCollection.gif'),
        mask_modal_url: 'https://cemoy.com/shop/products/product_cat-mask-collection/',



        swiper_modal_title: <>RE-VITAL EXPERT <br />DEFENCE</>,
        swiper_modal_subtitle: 'SOFTEN, SMOOTH AND SPF PROTECTION',
        swiper_modal_content: <>Our Re-Vital Expert Defence primer is a take on Greek mythology meets modern day Japanese and Australian technology. A lightweight formula that treats, moisturises and protects all in one.
            <br />
            <br />
            We drew inspiration from Apollo, God of Sun and Light. Here he is depicted protecting Daphne who is enjoying the splendorous Australian sun with Cupid.
            <br />
            <br />
            CEMÔY's scientific research team developed the exclusive LFD lipophilic quick-drying technology that leaves no white residue, is lightweight, non-irritating and deeply hydrating.
        </>,
        swiper_modal_url: 'https://cemoy.com/shop/product/sun-collection/re-vital-expert-defence/',
        swiper_modal_tip: 'SLIDE TO VIEW GALLERY',

        pdf_modal_title: <>PRODUCT BIBLE</>,
        pdf_modal_subtitle: 'KNOWLEDGE IS POWER',
        pdf_modal_content: <>Consumers of the beauty industry are demanding transparency and we are fully on board. CEMÔY customers should be informed what our products are formulated with. Providing ingredient information and the opportunity to test the products, allows our customers to have a better understanding of how CEMÔY products will work with their skincare needs and existing routine.
            <br /><br />
            Easy access to CEMÔY's Product Bible is a step towards our transparency journey.
        </>,
        pdf_modal_img: require('@/files/modal/pdf/pdf-img.jpg'),
        pdf_modal_url: '/vr/CEMOY-Product-Bible.pdf',

        face_modal_title: <>EXPLORE <br /> OUR PRODUCTS</>,
        face_modal_dot1_subtitle: 'WHERE YOUR SKINCARE JOURNEY BEGINS',
        face_modal_tip: 'CLICK TO SEE MORE',
        face_modal_dot1_content: <> <p>EYE CARE</p>
            <p>
                The eyes are the window to our soul. Our eyes are prone to show the earliest signs of premature aging as the skin surrounding them is thinner and more delicate.
            </p>
            <p>
                Whether you are looking at prevention or targeting deeper set lines, we recommend our Timekeeper Eye Serum along with the Galaxy 4D Eye Cream.
            </p>
            <ul>
                <li><a href="https://cemoy.com/shop/product/eye-collection/timekeeper-eye-serum/" target='_blank' rel="noreferrer">Timekeeper Eye Serum</a></li>
                <li><a href="https://cemoy.com/shop/product/eye-collection/galaxy-4d-eye-cream/" target='_blank' rel="noreferrer">Galaxy 4D Eye Cream</a></li>
            </ul>
        </>,
        face_modal_dot2_content: <> <p>FIRMING AND PRO-AGING</p>
            <p>
                As we age, our skin begins to lose elasticity and it starts developing fine lines and wrinkles.
            </p>
            <p>
                By harnessing active ingredients such as our very own BLUTIVE™ compound, our Orbital Prestige Series is working at the cellular level to deliver radiant youthful-looking skin.
            </p>
            <ul>
                <li><a href="https://cemoy.com/shop/products/product_cat-orbital-prestige-series/" target='_blank' rel="noreferrer">Orbital Prestige Series</a></li>
            </ul>
        </>,
        face_modal_dot3_content: <><p>INTENSE REPAIR AND LUMINOSITY</p>
            <p>
                Not listening to the needs of your skin can at times result in a damaged skin barrier due to a combination of over exfoliating or skin sensitivity. The Lumen Series by CEMÔY has been formulated to specifically help repair and build a stronger skin barrier.
            </p>
            <p>
                Our research and development scientists have carefully selected ingredients from around the world to ensure optimum results and safety for all skin types.
            </p>
            <ul>
                <li><a href="https://cemoy.com/shop/products/product_cat-the-lumen-series/" target='_blank' rel="noreferrer">The Lumen Series</a></li>
            </ul>
        </>,
        face_modal_dot4_content: <><p>BEAUTY ELIXIRS</p>
            <p>
                Over the years, a number of products have been introduced to our skincare routine. Some have come and gone but serums remain a staple for a reason. CEMÔY serums are formulated utilising premium quality ingredients to obtain maximum results.
            </p>
            <p>
                The neck and decolletage are one of the first areas to show signs of aging. Often neglected, it is important that we look after it as it is just as susceptible to forming fine lines and wrinkles similar to those around your face.
            </p>
            <p>
                In order to prevent premature aging, we recommend:
            </p>
            <ul>
                <li><a href="https://cemoy.com/shop/products/product_cat-21-day-series/" target='_blank' rel="noreferrer">21 Day Series</a></li>
                <li><a href="https://cemoy.com/products/meadowfoam-moistening-oil/" target='_blank' rel="noreferrer">Meadowfoam Moistening Oil</a></li>
            </ul>
        </>,
        face_modal_dot5_content: <>
            <p>PREVENT AND REPAIR</p>
            <p>
                The first line of defence against anti-aging is prevention. Stopping the aging process in its tracks begins with a solid skincare routine that includes UV protection. Whether you are looking at repairing your damaged skin barrier or protecting your skin from environmental pollution, CEMÔY skincare range has you covered.
            </p>
            <ul>
                <li><a href="https://cemoy.com/shop/product/sun-collection/re-vital-expert-defence/" target='_blank' rel="noreferrer">Re-Vital Expert Defence</a></li>
                <li><a href="https://cemoy.com/shop/product/30-second-miracle-toner/30-second-miracle-toner/" target='_blank' rel="noreferrer">30-Second Miracle Toner</a></li>
                <li><a href="https://cemoy.com/shop/product/inception-sleeping-cream-mask/inception-sleeping-cream-mask/" target='_blank' rel="noreferrer">Inception Sleeping Cream & Mask</a></li>
                <li><a href="https://cemoy.com/shop/products/product_cat-mask-collection/" target='_blank' rel="noreferrer">Mask Collection</a></li>
            </ul>
        </>,
    },
    ch:{
        modal_back_btn: '返回',
        modal_shop_btn: '购买',
        modal_download_btn: '下载手册',
        modal_img_show_icon: require('@/files/modal/imglist/zoomIn.png'),
        modal_click_img: require('@/files/modal/clickHand.png'),
        modal_swiper_img: require('@/files/modal/leftRightHand.png'),

        modal_s1_w1_video_title: <>美艺共生</>,
        modal_s1_w1_video_subtitle: '聆听艺术 看见至美',
        modal_s1_w1_video_content: <>走进CEMÔY灵感世界，探寻灵魂艺术作品的隽永真谛，在CEMÔY创意总监Paul Foley对美的解读中「看见更多」。赋至美以灵感，予生命以观照，共启一段美学与艺术的交融对话，感受每件作品的灵魂与温度，激发美的无尽灵感。</>,
        modal_s1_w1_video_img: require('@/files/modal/img/CEMOY-Gallery-S01-W1-P1-S-CN-CD.jpg'),
        modal_s1_w1_video_video: require('@/files/modal/video/CEMOY-Gallery-S01-W1-V1-CN-CD.mp4'),

        modal_s2_w1_imglist_title: <>「澳」秘寻美</>,
        modal_s2_w1_imglist_subtitle: '无垠想象 无远弗届',
        modal_s2_w1_imglist_content: [
            <><h1>《守护者》</h1>
                <br />
                <h2>呼吸间，去发现自然疗愈的秘密。</h2>
                <br />
                创作年份：2019
                <br />
                绘制媒介：钢笔和水墨绘画
                <br />
                清晨的细雨降临橄榄树林，成片的金合欢自由生长，历经冬日沉睡后，于春日灿然绽放，跃动的绿意交织让世界变得鲜明。林间食蚁兽自在穿梭，与身后鸸鹋玩闹嬉戏追逐，快乐惬意。阳光穿过橄榄树林，与盛放华丽的白花交织。动物披挂着华丽的珠宝，安瓶状的轻巧瓶身化作灵巧的乐器，在嬉戏中激荡出清脆的音符，此刻感官与自然轻盈相融，愉悦、治愈感随之漫溢。
                <Divider className={styles.contentDivider} />
                CEMÔY安瓶海藻修护面膜
                <br /> <br />
                橄榄树林守护着澳洲国宝级动物鸸鹋与食蚁兽，正如富含油橄榄叶提取物的澳诗茉安瓶海藻面膜守护你的肌肤，予你自在安心。</>,
            <><h1>《石榴》</h1>
                <br />
                <h2>踏足梦幻奇境，升华内在遐思</h2>
                <br />
                创作年份：2019
                <br />
                绘制媒介：钢笔和水墨绘画
                <br />
                踏入如梦似幻的澳洲自然森林，林中盛放着绚丽的石榴花卉，大极乐鸟、澳洲矮袋鼠、袋熊、美冠鹦鹉、负鼠自在嬉戏其间。画面亦如镜头，捕捉到树下动物欢快嬉戏的身影, 无垠想象与森林万物快乐共舞，灵动惬意地展现自然之美。
                <Divider className={styles.contentDivider} />
                CEMÔY石榴活力焕彩面膜
                <br /> <br />
                石榴活力焕彩面膜满蕴澳洲石榴精粹，激发肌肤无尽能量，焕发健康光采，如同传递快乐的澳洲短尾鼠，尽享活力与欢愉。</>,
            <><h1>《海洋》</h1>
                <br />
                <h2>广袤海洋潮汐翻涌，蕴藏源源生机能量。</h2>
                <br />
                创作年份：2019
                <br />
                绘制媒介：钢笔和水墨绘画
                <br />
                纵身跃入深海，在无限蔚蓝里和鲸鱼不期而遇，身旁是鲸鱼宝宝以及澳洲特色动物鸭嘴兽自在穿梭。吟唱的海豚、腾跃的鲸鱼和涌动的鱼群，一跃而激荡起的海浪演绎着自由的力量和生机。一切从容、自在、生机盎然，与自然的完全交融赋予身心无限力量。
                <Divider className={styles.contentDivider} />
                CEMÔY提升紧致黑面膜
                <br /> <br />
                CEMÔY从这片深邃蔚蓝中探寻灵感，将海洋的神秘修护紧致力量，封存于南极冰川黑面膜中。</>,
            <><h1>《蜂之王》</h1>
                <br />
                <h2>与自然相拥，自有治愈的灵魂。</h2>
                <br />
                创作年份：2019
                <br />
                绘制媒介：钢笔和水墨绘画
                <br />
                漫步疗愈花海与森林，感受澳洲独有麦卢卡红茶树下氤氲的香气……花香浮动鼻尖，温柔疗愈清澈灵动。停驻在枝头，忙碌不休的是蜂王与他勤劳的蜜蜂们。万般美好，汇于蜜中献给最尊贵的客人—袋鼠女王，花瓣落在女王的披肩上化作华美的图案，蜂蜜则呵护着她的金色毛发。
                <Divider className={styles.contentDivider} />
                CEMÔY麦卢卡蜂蜜面膜
                <br /> <br />
                CEMÔY麦卢卡蜂蜜面膜，以能量重新定义，深澈滋养肌肤，带来一场来自澳洲的奢养SPA，重获年轻掌握力。
            </>],
        modal_s2_w1_imglist_url:  [
            '',
            '',
            '',
            ''
        ],
        modal_s2_w1_imglist_sizes:[
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
        ],
        modal_s2_w1_imglist_sizes_mobile:[
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
        ],
        modal_s2_w1_imglist_imglist: [
        {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S02-W1-P1-Ampoule.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S02-W1-P1-Ampoule.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S02-W1-P1-Ampoule.jpg'),
            thumbnailWidth: '50vw'
        },
        {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S02-W1-P2-Pomegranate.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S02-W1-P2-Pomegranate.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S02-W1-P2-Pomegranate.jpg'),
            thumbnailWidth: '50vw'
        },
        {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S02-W1-P3-Ocean.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S02-W1-P3-Ocean.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S02-W1-P3-Ocean.jpg'),
            thumbnailWidth: '50vw'
        },
        {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S02-W1-P4-Honey.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S02-W1-P4-Honey.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S02-W1-P4-Honey.jpg'),
            thumbnailWidth: '50vw'
        }
        ],

        modal_s3_w1_img_title: <>《绽放》</>,
        modal_s3_w1_img_subtitle: '匠心独蕴，方唤肌肤恒久绽现',
        modal_s3_w1_img_content: <>
            创作年份：2020
            <br />
            绘制媒介：水粉绘画
            <br />
            绮丽缤纷的百花于周身绽放，带你步入花园之门，穿过光影交织的曼妙水幕一览芬芳奇境，斑驳层叠的树影，光影交织的意象完美呈现。部分花叶片犹如针线的刺绣，贯以巧思，融汇珍贵匠艺，将美丽与匠心永恒地镌刻于布料上，以此向工匠人致敬，对匠心精研、匠艺雕琢每一款作品的致敬。
            <Divider className={styles.contentDivider} />
            CEMÔY时光修护眼精华
            <br /> <br />
            CEMÔY是自然与科技护肤的倡导者，不仅为美而来，更崇尚富有内涵底蕴的生活方式与态度，以此为己任研发创作我们的每一款产品。当揭开这份百花绽放，另一份惊奇的美跃然而上。</>,
        modal_s3_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S03-W1-P1-S-Timekeeper.jpg'),
        modal_s3_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S03-W1-P1-Timekeeper.jpg'),
        modal_s3_w1_img_url: 'https://detail.tmall.com/item.htm?spm=a1z10.5-b-s.w4011-21968410582.57.69591160KYzyj0&id=638290703194&rn=43da5a02eecb513b5a5c30d33a97c6a3&abbucket=6&skuId=4571907284894',
        modal_s3_w1_img_sizes: [70, 80, 90, 100],

        modal_s4_w1_img_title: <>《无界共研》</>,
        modal_s4_w1_img_subtitle: '无界寻觅，开启科技修护之旅',
        modal_s4_w1_img_content: <>
            创作年份：2018
            <br />
            绘制媒介：钢笔手绘
            <br />
            广袤无垠的澳洲纯净土壤，开启CEMÔY最初的修护追寻之旅，无畏寻觅，翻越山川密林，探寻蔚蓝深处，采撷海陆珍稀修护植萃。历经无数次的试验与调配，CEMÔY研究室的药剂师最终研制出品牌明星产品—21天®系列精华。满蕴海陆珍奇植萃与前沿科技成分：海茴香、褐藻、极光粒子®、二裂酵母、富勒烯等，凝精华于一身，感受护肤科技的尖端实力。
            <Divider className={styles.contentDivider} />
            CEMÔY 21天®日光早安精华 & 21天®极光晚安精华
            <br /> <br />
            这幅《历程图》是21天®精华从采集、研发与生产的故事，这不仅仅是CEMÔY产品开发精益求精的真实写照，更是开启肌肤焕变之门，CEMÔY的修护探索也由此开始。</>,
        modal_s4_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S04-W1-P1-S-21-Day.jpg'),
        modal_s4_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S04-W1-P1-21-Day.jpg'),
        modal_s4_w1_img_url: 'https://cemoy.tmall.com/category-1510856451.htm?spm=a1z10.3-b-s.w4011-21968410585.3.46883e4dRASDvD&search=y#TmshopSrchNav',
        modal_s4_w1_img_sizes: [70, 80, 90, 100],
        modal_s4_w1_img_sizes_mobile: [90, 100, 110, 120],

        modal_s5_w1_img_title: <>《闺中之物》</>,
        modal_s5_w1_img_subtitle: '闺中臻宠，邂逅美好',
        modal_s5_w1_img_content: <>
            创作年份：2021
            <br />
            绘制媒介：彩铅手绘和电脑绘制
            <br />
            从闺蜜间真挚的陪伴与情谊中获得灵感，开启一段“肌肤与科学成分共同探索年轻”的旅程，深入修护滋养，焕发肌肤光耀新生。插画元素选择了女生的闺中之物，如象征着美丽服饰的缎带、布匹、吊穗；寓意时间与典藏的收纳盒、金杯，象征着自信与独立精神的皇冠与权杖。描绘出一间悦纳珍宝的闺房，希望女生们时刻保持美丽，充满自信，展现了蓝闺蜜®传递的美好愿景。
            <Divider className={styles.contentDivider} />
            CEMÔY澳铂蓝耀®系列（蓝闺蜜®系列）
            <br /> <br />
            CEMÔY 期待蓝闺蜜®系列的产品可以成为消费者心目中的“闺中之物”，陪伴其品味成长与时光滋养的美好。以蓝色能量作为产品主题色，传递品牌将天然的核心自然成分搭配领先科学技术BLUTIVE®，多赛道助攻抗初老。</>,
        modal_s5_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S05-W1-P1-S-Orbital-Prestige.jpg'),
        modal_s5_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S05-W1-P1-Orbital-Prestige.jpg'),
        modal_s5_w1_img_url: 'https://detail.tmall.com/item.htm?spm=a220o.1000855.w5001-23492742869.4.188c4771cJvQa8&id=655483152201&rn=097893596f67ca368e6d39f98233c89d&abbucket=12&scene=taobao_shop',
        modal_s5_w1_img_sizes: [70, 80, 90, 100],
        modal_s5_w1_img_sizes_mobile: [90, 100, 110, 120],

        modal_s6_w1_img_title: <>《日光桂冠》</>,
        modal_s6_w1_img_subtitle: '爱美无界，向阳绽放自我',
        modal_s6_w1_img_content: <>
            创作年份：2019
            <br />
            绘制媒介：电脑绘制
            <br />
            将古希腊神话与现代日本、澳大利亚的前沿科技相碰撞，小太阳与白月光——阳光防御系列应运而生。灵感启自太阳神阿波罗的神话故事——阿波罗将自己的披肩赠与心爱之神达芙妮，保护着达芙妮让她免受烈日灼伤，恣意享受阳光。画作绘制了达芙妮与阿波罗在澳大利亚悉尼著名的邦德海滩享受阳光与嬉闹世外桃源般的景象。
            <Divider className={styles.contentDivider} />
            CEMÔY阳光防御系列 小太阳&白月光
            <br /> <br />
            CEMÔY愿世间众人都能受到爱的加冕，也愿小太阳与白月光产品可以给消费者最好的呵护。触感莹润，集防晒、养肤于一体，契合阿波罗与达芙妮的日光桂冠神话故事，寓意为用户提供对阳光的防御与对肌肤的呵护。</>,
        modal_s6_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S06-W1-P1-S-Sun.jpg'),
        modal_s6_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S06-W1-P1-Sun.jpg'),
        modal_s6_w1_img_url: 'https://cemoy.tmall.com/search.htm?orderType=defaultSort&viewType=grid&keyword=%B7%C0%C9%B9&lowPrice=&highPrice=',
        modal_s6_w1_img_sizes: [70, 80, 90, 100],
        modal_s6_w1_img_sizes_mobile: [90, 100, 110, 120],

        modal_s7_w1_img_title: <>《循梦繁花》</>,
        modal_s7_w1_img_subtitle: '繁花入梦，万物生光',
        modal_s7_w1_img_content: <>
            创作年份：2020
            <br />
            绘制媒介：水彩绘画
            <br />
            小陀螺®睡眠面膜霜带你走进一场关于修护的梦境——深海鱼油、苦橙花等成分，在每一个夜间黄金时期释放强大修护力。偶然闯进造梦师的世界，这里有绽放的花卉、飞舞的花瓣、交错的建筑空间、柱廊、台阶与艺术相互交织，坠入美妙梦境的奇异幻想，与百花进行一场心灵的对话，探索美与永恒。
            <Divider className={styles.contentDivider} />
            CEMÔY小陀螺®睡眠面膜霜
            <br /> <br />
            画中世界除了花卉本身具备的藕粉色以及建筑的米棕色外，选用了与产品、品牌主题色相呼应的金色与宝蓝色。带你步入CEMÔY的梦境花园，感受优雅奢悦的曼妙艺术，与产品功效相呼应，开启美妙睡梦护肤之旅。</>,
        modal_s7_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S07-W1-P1-S-Inception.jpg'),
        modal_s7_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S07-W1-P1-Inception.jpg'),
        modal_s7_w1_img_url: 'https://detail.tmall.com/item.htm?id=626892963220&skuId=4614973827491',
        modal_s7_w1_img_sizes: [70, 80, 90, 100],
        modal_s7_w1_img_sizes_mobile: [90, 100, 110, 120],

        modal_s8_w1_imglist_title: <>《威斯康蒂》</>,
        modal_s8_w1_imglist_subtitle: '采撷月光与花语，解码肌肤凝时密码',
        modal_s8_w1_imglist_content: [<>
            创作年份：2021
            <br />
            绘制媒介：钢笔手绘
            <br />
            画幅展现出珍萃缠绕的澳秘花园与神秘而奇幻的塔罗牌世界：请在被浪漫与爱侵袭的月夜走进这个充满美丽幻象的月夜，以此致敬美的力量。世界女神在命运之轮中优雅起舞，同勇敢的愚人一起，宣告世界万物始启循环新生；象征智慧与直觉的女祭司化作澳秘世界的明镜，采撷月光与花语，解码肌肤凝时密码；八芒星于夜空中闪烁，与月光交相辉映，映照胜利的战车与权杖愈发光芒万丈；翩然闪烁的娇柔白花，饱满麦穗生长围绕着女皇宝座，哄睡顽皮的狮子，共谱华美乐章；不死鸟朱鹭沐浴在生命之泉中，沉浸感受着静谧的疗愈能量。
            <Divider className={styles.contentDivider} />
            CEMÔY白池花肌底精华油
            <br /> <br />
            CEMÔY从现存最古老的威斯康提（Visconti-Sforza）塔罗牌图像中汲取灵感，追溯15世纪古老而又神秘的养肤愈颜秘籍，以千年天然植萃，缔造白池花肌底精华油，以油温柔疗愈肌肤情绪，开启你的精华油焕肤之旅。
        </>],
        modal_s8_w1_imglist_url: 'https://detail.tmall.com/item.htm?id=661360545270&skuId=4941300874851',
        modal_s8_w1_imglist_imglist: [
        {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P1-S-Taro.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P1-S-Taro.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S08-W1-P1-Taro.jpg'),
            thumbnailWidth: '50vw'
        },
        {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P2-S-Taro.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P2-S-Taro.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S08-W1-P2-Taro.jpg'),
            thumbnailWidth: '50vw'
        },
        {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P3-S-Taro.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P3-S-Taro.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S08-W1-P3-Taro.jpg'),
            thumbnailWidth: '50vw'
        },
        {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P4-S-Taro.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P4-S-Taro.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S08-W1-P4-Taro.jpg'),
            thumbnailWidth: '50vw'
        },
        {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P5-S-Taro.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P5-S-Taro.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S08-W1-P5-Taro.jpg'),
            thumbnailWidth: '50vw'
        },
        {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P6-S-Taro.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P6-S-Taro.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S08-W1-P6-Taro.jpg'),
            thumbnailWidth: '50vw'
        },
        {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P7-S-Taro.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S08-W1-P7-S-Taro.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S08-W1-P7-Taro.jpg'),
            thumbnailWidth: '50vw'
        }
        ],
        modal_s8_w1_imglist_sizes:[
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
        ],
        modal_s8_w1_imglist_sizes_mobile:[
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
        ],
        modal_s9_w1_img_title: <>《耀目》</>,
        modal_s9_w1_img_subtitle: '熠熠生辉，流转间闪耀动人神采',
        modal_s9_w1_img_content: <>
            创作年份：2020
            <br />
            绘制媒介：电脑绘制
            <br />
            这是一副由错落有致的各式八边形图案拼接而成的连续画卷，犹如耀目的钻石折射面所形成的万花筒，闪烁晶璨光耀。日晷发展于13世纪，是观测日影记时的仪器。插画周围点缀着日晷的刻度线，在光下折射出金色耀眼的光芒，时刻提醒着我们：放慢脚步吧，享受护肤的美好，守住年轻与美丽。
            <Divider className={styles.contentDivider} />
            CEMÔY时光修护眼精华
            <br /> <br />
            插画以耀目的钻石、记录时间的日晷为切入点，时光流转，定格少女耀明明眸的秘密源于CEMÔY时光修护眼精华，抹去岁月的痕迹，把眼角的闪耀光芒留存在此刻。</>,
        modal_s9_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S09-W1-P1-S-Timekeeper.jpg'),
        modal_s9_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S09-W1-P1-Timekeeper.jpg'),
        modal_s9_w1_img_url: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-21968410585.193.61e63e4dnbTYxX&id=638290703194&rn=bf6e6cd14e0d1dc76f296a51632e0870&abbucket=6&skuId=4571907284894',
        modal_s9_w1_img_sizes: [70, 80, 90, 100],
        modal_s9_w1_img_sizes_mobile: [90, 100, 110, 120],

        modal_s10_w1_img_title: <>《梦想花》</>,
        modal_s10_w1_img_subtitle: '灵感梦境牵引，让肌肤探索无畏直前',
        modal_s10_w1_img_content: <>
            创作年份：2019
            <br />
            绘制媒介：彩铅手绘
            <br />
            灵感之境正缓缓开启，邂逅梦想中的植物与花卉，芬芳流动，如临其境，植物优美而奇特，坚韧地绽放，蕴能生命力，氤氲出一片缥缈仙境；缀满果实的枝叶随风摇曳，仿若悠静庭院中生机盎然的错落树影。在蓝色星空背景的衬托下，描绘出浩瀚外太空星球的花卉海洋。
            <Divider className={styles.contentDivider} />
            CEMÔY 4D反重力®飞碟眼霜
            <br /> <br />
            以“神秘外星植物与花卉”轮廓形象，结合星空、海浪、云图等造型，组成的一副充满浪漫、奇幻色彩的场景，带领我们展开对无重力星空的无限遐想，勇于探索无限的未知世界。</>,
        modal_s10_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S10-W1-P1-S-Galaxy.jpg'),
        modal_s10_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S10-W1-P1-Galaxy.jpg'),
        modal_s10_w1_img_url: 'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-21968410585.80.67163e4d6iHAFq&id=612851982267&rn=950584430c6237ec83c46a13de3a85e1&abbucket=6',
        modal_s10_w1_img_sizes: [70, 80, 90, 100],
        modal_s10_w1_img_sizes_mobile: [90, 100, 110, 120],

        modal_s11_w1_imglist_title: <>臻礼典藏</>,
        modal_s11_w1_imglist_subtitle: '凝萃至臻 逾越时空',
        modal_s11_w1_imglist_content: [
            <><h1>《典藏》</h1>
                <br />
                <h2>典藏岁月，收纳时光</h2>
                <br />
                创作年份：2019
                <br />
                绘制媒介：电脑绘制
                <br />
                以浸满少女情怀的蝴蝶结，装饰复古画框；以金色灵动的植物花卉，缠绕庄严舞台。耀眼且精致，活泼亦庄重，年轻本就鲜活多变，自在闪耀。悦纳自我，典藏时光。随着内外盒的缓慢结合，岁月的痕迹正在细细隐藏。
                <Divider className={styles.contentDivider} />
                CEMÔY白金流明®系列 季节套装
                <br /> <br />
                以天然的核心自然成分搭配领先的科学技术，CEMÔY将白金流明®系列中的至奢宠爱，逾17种植物成分镌刻为恒，献给每一个勇敢寻美的你，带着丰盛的自己追逐未来的光，这份勇敢值得典藏。</>,
            <><h1>《极地希望》</h1>
                <br />
                <h2>光耀流明，愈美新生</h2>
                <br />
                创作年份：2021
                <br />
                绘制媒介：钢笔和电脑绘制
                <br />
                光踏着宇宙穿越几亿光年，此刻已然到来。远处耀眼的光束，显映着石榴籽的晶莹剔透，女王、国王与骑士三枚象棋棋子也如同被光赋予生命一般生动，如同塔罗牌中的太阳牌，带来希望与新生。爱是自然界的第二个太阳。在爱中寻得希望，在希望中找到力量。如阳光照拂下坚韧生长的植物，向美而生。
                <Divider className={styles.contentDivider} />
                CEMÔY白金流明®系列  季节套装
                <br /> <br />
                白金流明®系列以光通量的单位命名，搜寻海陆之珍奇植萃，尽释修护卓能，如同被光穿过的通透感，肌肤越见柔光水嫩。</>,
            <><h1>《秘境》</h1>
                <br />
                <h2>循着光，寻找神秘林中的美肌宝藏</h2>
                <br />
                创作年份：2021
                <br />
                绘制媒介：钢笔和水墨绘画
                <br />
                是一束秘光的偶然划过，指引着探寻神秘林中的圣殿，历经时光的洗礼，圣殿宏伟依然。四周暗影被光嚼碎，点缀殿堂的端庄。殿顶、台阶与光的嬉戏创造出神秘空间，如同魔比斯环，象征无尽与永恒。
                <Divider className={styles.contentDivider} />
                CEMÔY白金流明®系列 季节套装
                <br /> <br />
                寻美旅程，以光唯伴。「秘境礼盒」满赋修护力，启光耀之美，指引你踏上秘光探宝的奇妙旅程。现在，开启圣殿的大门，唤醒内在光耀，臻启你的肌肤之美。</>,
            <><h1>《怒放》</h1>
                <br />
                <h2>日日臻养，光显于韧，静待怒放</h2>
                <br />
                创作年份：2021
                <br />
                绘制媒介：丙烯绘画
                <br />
                美不止有玫瑰，一花一木皆有境意。是马齿苋，是北美金缕梅，是雪莲花、亦或是海茴香，争相怒放于CEMÔY的无界花园之中。美，从不被界定，无畏烈阳风雨，自由傲立，定格恒绽之美。
                <Divider className={styles.contentDivider} />
                CEMÔY白金流明®系列  季节套装
                <br /> <br />
                CEMÔY将怒放的美，显于白金流明®系列中。白金流明®以光通量的单位命名，度量肌肤亮感数值，肌肤如同沐浴晨光的花苞，满蕴修护力，日日臻养，光显于韧，静待怒放。</>,
            <><h1>《追光》</h1>
                <br />
                <h2>若不适黑暗，就站在舞台中央</h2>
                <br />
                创作年份：2021
                <br />
                绘制媒介：电脑绘制
                <br />
                华美的金属装饰、精美的手工雕刻，巴洛克以热情、自信美的风格席卷16世纪欧洲每一位贵妇的梳妆台。CEMÔY从《奥兰多》中汲取灵感，以《舞台》带来一场还原16世纪梳妆台的魔术表演，待象征着光的圆月转动，角色依次登上舞台，追光序幕由此揭开。
                <Divider className={styles.contentDivider} />
                CEMÔY白金流明®系列 季节套装
                <br /> <br />
                追光礼盒以白金流明®为灵感源，以光通量的单位命名，度量肌肤亮感数值，旨在通过修护滋养、焕亮柔润，赋予肌肤健康，如同舞台中央的表演家，时刻释放自信光芒。
            </>],
        modal_s11_w1_imglist_url: [
            'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-21968410585.44.67163e4d6iHAFq&id=600756402459&rn=950584430c6237ec83c46a13de3a85e1&abbucket=6',
            'https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-21968410585.64.67163e4d6iHAFq&id=644693073236&rn=950584430c6237ec83c46a13de3a85e1&abbucket=6',
            '',
            '',
            ''
        ],
        modal_s11_w1_imglist_sizes:[
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
            [30, 40, 50, 60],
        ],
        modal_s11_w1_imglist_sizes_mobile:[
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
          [80, 85, 90, 100],
        ],
        modal_s11_w1_imglist_imglist: [
        {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P1-S-Classics.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P1-S-Classics.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S11-W1-P1-Classics.jpg'),
            thumbnailWidth: '50vw'
        },
        {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P2-S-Hope.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P2-S-Hope.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S11-W1-P2-Hope.jpg'),
            thumbnailWidth: '50vw'
        },
        {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P3-S-Secret.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P3-S-Secret.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S11-W1-P3-Secret.jpg'),
            thumbnailWidth: '50vw'
        },
        {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P4-S-Freshness.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P4-S-Freshness.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S11-W1-P4-Freshness.jpg'),
            thumbnailWidth: '50vw'
        },
        {
            original: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P5-S-Stage.jpg'),
            thumbnail: require('@/files/modal/imglist/thumbnails/CEMOY-Gallery-S11-W1-P5-S-Stage.jpg'),
            thumbnail_big: require('@/files/modal/imglist/orgional/CEMOY-Gallery-S11-W1-P5-Stage.jpg'),
            thumbnailWidth: '50vw'
        }
        ],

        modal_s12_w1_img_title: <>《无界花园》</>,
        modal_s12_w1_img_subtitle: '星夜寻梦，邂逅无界花园',
        modal_s12_w1_img_content: <>
            创作年份：2018
            <br />
            绘制媒介：手绘和电脑绘制
            <br />
            仿佛步入秘境花园，来自秘境深处的马齿苋、北美金缕梅，以灵动的植萃气息，开启一场修护探秘之旅；重重珍稀植被覆盖着花园，目之所及无有边界，耳边传来复活草、海茴香随风而起的静谧私语，内心被不断治愈着，一切宛如梦境般，在植物的怀抱中愈发安心且纯净，令人沉入其中，不愿醒来。
            <Divider className={styles.contentDivider} />
            CEMÔY白金流明®系列
            <br /> <br />
            这幅作品，绘制涵盖了白金流明®1.0系列当中的逾17种独特自然成分，是对研发团队跋山涉水长达一年研发历程的致敬，同时呼应护肤品结合自然精华与尖端科技的研发初心。白金流明®系列，度量肌肤光感数值，搜寻海陆之珍奇植萃，辅以科技研力，尽释修护卓能。</>,
        modal_s12_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S12-W1-P1-S-Lumen.jpg'),
        modal_s12_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S12-W1-P1-Lumen.jpg'),
        modal_s12_w1_img_url: 'https://cemoy.tmall.com/category-1510856450.htm?spm=a1z10.3-b-s.w4011-21968410585.2.54b53e4du1X3DB&tsearch=y&orderType=defaultSort&scene=taobao_shop#TmshopSrchNav',
        modal_s12_w1_img_sizes: [70, 80, 90, 100],
        modal_s12_w1_img_sizes_mobile: [90, 100, 110, 120],

        modal_s13_w1_img_title: <>《万物生》</>,
        modal_s13_w1_img_subtitle: '生生不息，水润万物从此刻苏醒',
        modal_s13_w1_img_content: <>
            创作年份：2019
            <br />
            绘制媒介：钢笔、水墨和拼贴
            <br />
            插画灵感源于澳大利亚神奇的植被、丰富的人文环境，这无一不启示着我们的护肤研发灵感。从酿酒酵母中惊奇发现修护成分——三重酵母原生神经酰胺，出色的亲肤性令肌肤更细腻弹润，也印证了在久负盛名的南澳巴罗萨谷，亦能找到护肤奥秘。万物栖息于大自然中，在它们踏足的花卉草木中重获生机，这片雨林蕴藏着无限的浪漫惊喜。
            <Divider className={styles.contentDivider} />
            CEMÔY神金水®
            <br /> <br />
            将自然万物生理念融入插画中，展现产品水润万物，滋润肌肤，望其重获生机的美好愿景。</>,
        modal_s13_w1_img_img: require('@/files/modal/img/CEMOY-Gallery-S13-W1-P1-S-Eternal.jpg'),
        modal_s13_w1_img_img_big: require('@/files/modal/img/big/CEMOY-Gallery-S13-W1-P1-Eternal.jpg'),
        modal_s13_w1_img_url: 'https://detail.tmall.com/item.htm?id=630591956792&skuId=4572098548299',
        modal_s13_w1_img_sizes: [30, 40, 50, 60],
        modal_s13_w1_img_sizes_mobile: [80, 85, 90, 100],

        modal_s14_w1_video_title: <>匠艺礼赞</>,
        modal_s14_w1_video_subtitle: '匠心之作 造物之诣',
        modal_s14_w1_video_content: <>CEMÔY敬献唤醒肌肤至美的匠艺乐章，于自然中回溯，于光阴中慢砌，于细节处打磨。每一步精雕细琢，向时间与耐心致敬。除了竭尽全力让你的肌肤变得更美，CEMÔY用匠心打造一个场域，一个容器，一个瞬间，安放你的所有愉悦欢喜，存放每一个你对万物的敬畏与想象。</>,
        modal_s14_w1_video_img: require('@/files/modal/img/CEMOY-Gallery-S14-W1-P1-S-CN-Craftsmanship.jpg'),
        modal_s14_w1_video_video: require('@/files/modal/video/CEMOY-Gallery-S14-W1-V1-Craftsmanship.mp4'),

        modal_s14_w2_video_title: <>悦享启赋</>,
        modal_s14_w2_video_subtitle: '灵感臻品 恒美内蕴',
        modal_s14_w2_video_content: <>
            奢美于外，大美于内，这是CEMÔY世界的理想状态。我们坚持以自然为本，修护为道，将自然萃取与尖端生物科技相融合。稀有精微，才属难能珍贵。CEMÔY匠心于科研的创新与突破，启赋极具奢美仪式感的护肤体验，独具匠心与慧眼，抵达当代趋势与至臻美学的平衡之境。
            <br /><br />
            随指尖轻触，沉浸感官交融的美妙，远见天地，近观自己，CEMÔY与你的寻美旅程，才刚启幕。
        </>,
        modal_s14_w2_video_img: require('@/files/modal/img/CEMOY-Gallery-S14-W2-P1-S-CN-Spa.jpg'),
        modal_s14_w2_video_video: require('@/files/modal/video/CEMOY-Gallery-S14-W2-V1-CN-Spa.mp4'),


        mask_modal_title: <>澳秘「膜」力系列<br />面膜</>,
        mask_modal_subtitle: '解锁美的奥秘',
        mask_modal_content: <>CEMÔY澳秘「膜」力系列面膜，每款面膜均蕴含澳大利亚独特的植物成分，以致敬澳大利亚的惊奇自然之美。
            <br />
            <br />
            独特设计的膜布，每一片都满载精粹活性成分。 膜布贴合每一寸肌肤，精华滋养每一层肌肤，享受 15分钟的护理过程后，臻启柔嫩细腻亮泽肌肤新境。
        </>,
        mask_modal_img: require('@/files/modal/maskCollection/maskCollection.gif'),
        mask_modal_url: 'https://cemoy.tmall.com/category-1510856452.htm?spm=a220o.1000855.w4010-21968410575.9.66b17eb1BG0sIq&search=y&catName=%B1%A3%CA%AA%C3%E6%C4%A4%CF%B5%C1%D0#bd',


        swiper_modal_title: <>阳光防御系列</>,
        swiper_modal_subtitle: '防御紫外线 莹润透光白',
        swiper_modal_content: <>灵感启自太阳神阿波罗与达芙妮的神话故事。象征着太阳与光明的阿波罗，倾慕着达芙妮。由于阿波罗的爱过于炽热，达芙妮无奈化为一棵月桂树，阿波罗因此伤心不已，将自己披肩赠予她，希望她免受烈日灼伤。
            <br />
            <br />
            披肩寓意「小太阳」，月桂树则寓意「白月光」，CEMÔY捕捉散落在故事中的零星美好，凝结于CEMÔY阳光防御系列，呵宠与你。
            <br />
            <br />
            <a href="https://detail.tmall.hk/hk/item.htm?id=616196588460" target='_blank' rel="noreferrer">小太阳阳光防御</a>
            <br />
            CEMÔY优选多重防晒成分、植物养肤成分，辅以LFD亲脂速干成膜技术，高倍防晒的同时兼顾养肤，质地轻盈，成膜迅速不结块，亦能防水防汗，长效养护你的肌肤。
            <br />
            <br />
            <a href="https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-21968410585.38.44f83e4dzBSrIY&id=635909676108&rn=7e2800c518d4d608459176378ba7e0b2&abbucket=14&skuId=4641639917614" target='_blank' rel="noreferrer">白月光阳光防御</a>
            <br />
            直面晒，白无暇。白月光防晒予你广谱全波段高倍防护，多种植物萃取，防晒更养肤美白，肌肤轻而易举透出光感，无畏白昼烈日，温柔发光。
        </>,
        swiper_modal_url: 'https://cemoy.tmall.com/search.htm?orderType=defaultSort&viewType=grid&keyword=%B7%C0%C9%B9&lowPrice=&highPrice=',
        swiper_modal_tip: '滑动浏览图片',

        pdf_modal_title: <>产品手册</>,
        pdf_modal_subtitle: '科技即美，智慧护肤',
        pdf_modal_content: <>CEMÔY是坚实的实践者，信息化时代的进程正逐步影响着消费者的认知。详尽的成分与功效信息，将为您带来更有效的美妆护肤体验，这也是CEMÔY一直以来坚守的方向。
            <br /><br />
            为了让您更好地判断CEMÔY产品是否符合您的肤质需求，我们将为您提供产品的详细信息以及成分，让您的护肤体验与智慧并行。
        </>,
        pdf_modal_img: require('@/files/modal/pdf/pdf-img-cn.jpg'),
        pdf_modal_url: '/vr/CEMOY-Product-Bible.pdf',

        face_modal_title: <>随肤定制</>,
        face_modal_dot1_subtitle: '专属奢宠方案',
        face_modal_tip: '点击面部图标了解更多方案',
        face_modal_dot1_content: <><p>抗皱·滋养</p>
            <p>
                眼部肌肤相较于面部肌肤更脆弱易衰老，因此，保养眼部肌肤刻不容缓。
            </p>
            <p>
                CEMÔY澳诗茉打造眼部护理系列产品「时光修护眼精华」、「4D反重力®飞碟眼霜」，令眼周肌肤更加弹润细滑，更显年轻态。
            </p>
            <ul>
                <li><a href="https://detail.tmall.com/item.htm?id=638290703194&skuId=4571907284894" target='_blank' rel="noreferrer">时光修护眼精华</a></li>
                <li><a href="https://detail.tmall.com/item.htm?id=612851982267&skuId=4744956222712" target='_blank' rel="noreferrer">4D反重力®飞碟眼霜</a></li>
            </ul>
        </>,
        face_modal_dot2_content: <><p>紧致·抗老</p>
            <p>
                随着年龄的增长，我们的皮肤逐渐失去弹性，并伴随着细纹和暗沉等初老现象。
            </p>
            <p>
                澳铂蓝耀系列，自研科学抗初老成分BLUTIVE®，协同多重修护成分，多赛道助攻抗初老。
            </p>
            <ul>
                <li><a href="https://cemoy.tmall.com/category.htm?orderType=&viewType=grid&keyword=%C0%B6%B9%EB%C3%DB&lowPrice=&highPrice=" target='_blank' rel="noreferrer">澳铂蓝耀系列</a></li>
            </ul>
        </>,
        face_modal_dot3_content: <><p>修护·维稳</p>
            <p>
                过度清洁或过度追求强功效，都有可能让肌肤产生不适，甚至加重屏障受损，变成敏感肌。CEMÔY为此研制出白金流明®系列。
            </p>
            <p>
                CEMÔY白金流明®系列，蕴含全球优质成分，温和、高效且安全，适用于每一种肤质。密集修护屏障、滋养焕亮，维稳润泽，帮助你的皮肤建立更强韧的皮肤屏障。
            </p>
            <ul>
                <li><a href="https://cemoy.tmall.com/category-1510856450.htm?spm=a1z10.3-b-s.w4011-21968410585.2.54b53e4du1X3DB&tsearch=y&orderType=defaultSort&scene=taobao_shop#TmshopSrchNav" target='_blank' rel="noreferrer">白金流明®系列</a></li>
            </ul>
        </>,
        face_modal_dot4_content: <><p>密集修护·焕亮</p>
            <p>
                随着用户护肤需求的增多，更多功能型产品被引入我们的护肤程序之中。但即便如此，在CEMÔY的产品开发体系中，始终将精华类目列为产品的核心之一，原因在于，精华中的有效成分含量更高，更能针对性解决肌肤问题。
            </p>
            <p>
                严重的肌肤问题，例如屏障受损或衰老，更需要使用精华类产品。CEMÔY「21天精华系列」、「白池花肌底精华油」蕴含高浓功效成分，赋予肌肤密集滋养与修护，焕现迷人健康光泽。
            </p>
            <ul>
                <li><a href="https://cemoy.tmall.com/category-1510856451.htm?spm=a1z10.3-b-s.w4011-21968410585.3.46883e4dRASDvD&search=y#TmshopSrchNav" target='_blank' rel="noreferrer">21天精华系列</a></li>
                <li><a href="https://detail.tmall.com/item.htm?id=661360545270&skuId=4941300874851" target='_blank' rel="noreferrer">白池花肌底精华油</a></li>
            </ul>
        </>,
        face_modal_dot5_content: <><p>防御提亮·修护屏障</p>
            <p>
                防御紫外线、强韧肌肤防御屏障、以及抵抗外界污染的侵害，已成为抗老的重要一步。CEMÔY护肤系列已涵盖多种功能，外在建立防御紫外线机制，内在修护肌肤屏障，滋养润弹，焕亮嫩白，肌肤如获细腻新生。
            </p>
            <ul>
                <li><a href="https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-21968410585.38.44f83e4dzBSrIY&id=635909676108&rn=7e2800c518d4d608459176378ba7e0b2&abbucket=14&skuId=4641639917614" target='_blank' rel="noreferrer">白月光防晒霜</a></li>
                <li><a href="https://detail.tmall.hk/hk/item.htm?id=616196588460" target='_blank' rel="noreferrer">小太阳日光防御</a></li>
                <li><a href="https://detail.tmall.com/item.htm?id=630591956792&skuId=4572098548299" target='_blank' rel="noreferrer">神金水</a></li>
                <li><a href="https://detail.tmall.com/item.htm?id=626892963220&skuId=4614973827491" target='_blank' rel="noreferrer">「小陀螺」睡眠面膜霜</a></li>
                <li><a href="https://cemoy.tmall.com/category-1510856452.htm?spm=a220o.1000855.w4010-21968410575.9.66b17eb1BG0sIq&search=y&catName=%B1%A3%CA%AA%C3%E6%C4%A4%CF%B5%C1%D0#bd" target='_blank' rel="noreferrer">澳秘「膜」力系列面膜</a></li>
            </ul>
        </>,
        face_modal_dot6_content: <><p>强化修护·光耀焕彩</p>
            <p>
            外界的环境污染、护肤不当、彩妆残留，以及熬夜、内在压力等因素，不仅易导致肌肤面部菌群紊乱，加重敏感，还会加重面色暗沉，肌肤黯淡无光。
            </p>
            <p>
            CEMÔY白金流明®「极地」系列，遍寻极地雪域，采撷与萃取极地极端环境下的雪域深处红莓精粹，并糅合全球优质成分，修护璨亮，澎弹充盈，唤启新生。
            </p>
            <ul>
                <li><a href="https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-21968410585.70.72243e4dG52N3J&id=652115659352&rn=aa04cd30eeb7a445f589bb32a571b7a7&abbucket=14&skuId=4696426104293" target='_blank' rel="noreferrer">白金流明®「极地」精华水</a></li>
                <li><a href="https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-21968410585.50.72243e4dG52N3J&id=656618638195&rn=aa04cd30eeb7a445f589bb32a571b7a7&abbucket=14&skuId=4907574430063" target='_blank' rel="noreferrer">白金流明®「极地」精华乳</a></li>
                <li><a href="https://detail.tmall.com/item.htm?spm=a1z10.3-b-s.w4011-21968410585.54.72243e4dG52N3J&id=655659791413&rn=aa04cd30eeb7a445f589bb32a571b7a7&abbucket=14&skuId=4729152021983" target='_blank' rel="noreferrer">白金流明®「极地」精华霜</a></li>
            </ul>
        </>,
    }
}

export function getContent(code, key){
    return contents[code][key]
}

// import { getContent } from './content.js'
// { getContent(language, 'xxxxxxxx') }
